const smoothScroll = {
  init() {
    if (window.location.hash) {
      const anchor = document.querySelector(window.location.hash);

      if (anchor) {
        anchor.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
  },
};

export default smoothScroll;
